import React, { useState } from 'react';
import axios from 'axios';
import '../styles/MediabrandsDocsUpload.css';

// Set up axios defaults
axios.defaults.withCredentials = true;
axios.defaults.headers.common['x-api-key'] = process.env.REACT_APP_CREATE_USER_API_KEY;

// Create an axios instance for file uploads
const fileUploadAxios = axios.create({
  withCredentials: true,
  headers: {
    'x-api-key': process.env.REACT_APP_CREATE_USER_API_KEY,
    'Accept': 'multipart/form-data'
  }
});

const MediabrandsDocsUpload = () => {
  const [formData, setFormData] = useState({
    title: '',
    publication_date: '',
    document_type: '',
    channels: '',
    topics: '',
    confidentiality_level: 'internal',
    regions: '',
    tags: '',
  });
  
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ loading: false, error: null, success: false, processing: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, error: null, success: false, processing: false });
    
    if (!file) {
      setStatus({
        loading: false,
        error: 'Please select a file to upload.',
        success: false,
        processing: false
      });
      return;
    }
    
    try {
      const submitData = new FormData();
      Object.keys(formData).forEach((key) => submitData.append(key, formData[key]));
      
      submitData.append('fileInput', file);

      const response = await fileUploadAxios.post(
        'https://n8n.iniai.cloud/webhook/upload-mediabrands-docs', 
        submitData
      );

      setStatus({ 
        loading: false, 
        error: null, 
        success: true,
        processing: true 
      });

      setFormData({
        title: '',
        publication_date: '',
        document_type: '',
        channels: '',
        topics: '',
        confidentiality_level: 'internal',
        regions: '',
        tags: '',
      });
      setFile(null);
      
    } catch (error) {
      console.error('Upload error details:', error.response || error);
      setStatus({ 
        loading: false, 
        error: error.response?.data?.message || error.message || 'Upload failed', 
        success: false,
        processing: false
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files?.[0]) {
      const selectedFile = e.target.files[0];
      console.log('Selected file size:', selectedFile.size / 1024 / 1024, 'MB');
      
      if (selectedFile.size > 45 * 1024 * 1024) { // 45MB limit
        setStatus({
          loading: false,
          error: 'File size must be less than 45MB',
          success: false,
          processing: false
        });
        return;
      }
      setFile(selectedFile);
    }
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Upload Mediabrands Document</h2>
      <p className="form-subtitle">Submit your document upload request</p>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Document Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter document title"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Publication Date</label>
          <input
            type="date"
            name="publication_date"
            value={formData.publication_date}
            onChange={handleChange}
            required
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Document Type</label>
          <input
            type="text"
            name="document_type"
            value={formData.document_type}
            onChange={handleChange}
            required
            className="form-input"
            placeholder="Enter document type"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Channels</label>
          <input
            type="text"
            name="channels"
            value={formData.channels}
            onChange={handleChange}
            className="form-input"
            placeholder="Enter channels"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Topics</label>
          <input
            type="text"
            name="topics"
            value={formData.topics}
            onChange={handleChange}
            className="form-input"
            placeholder="Enter topics"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Confidentiality Level</label>
          <select
            name="confidentiality_level"
            value={formData.confidentiality_level}
            onChange={handleChange}
            className="form-select"
            required
          >
            <option value="public">Public</option>
            <option value="internal">Internal</option>
            <option value="confidential">Confidential</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Regions</label>
          <input
            type="text"
            name="regions"
            value={formData.regions}
            onChange={handleChange}
            className="form-input"
            placeholder="Enter regions"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Tags</label>
          <input
            type="text"
            name="tags"
            value={formData.tags}
            onChange={handleChange}
            className="form-input"
            placeholder="Enter tags (comma-separated)"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Document File</label>
          <input
            type="file"
            name="fileInput"
            onChange={handleFileChange}
            required
            className="form-input"
            accept=".pdf,.doc,.docx"
          />
        </div>

        {status.error && (
          <div className="form-error">
            {status.error}
          </div>
        )}

        {status.success && (
          <div className="form-success">
            {status.processing 
              ? 'Document uploaded successfully! Processing may take up to 20 minutes.'
              : 'Document uploaded and processed successfully!'}
          </div>
        )}

        <button
          type="submit"
          disabled={status.loading || !file}
          className="form-submit"
        >
          {status.loading ? 'Uploading...' : 'Upload Document'}
        </button>
      </form>
    </div>
  );
};

export default MediabrandsDocsUpload;
